import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"
import { UrlService } from "../core/services/UrlService";
import "./404.scss";

const NotFoundPage = () => {
    const localeUrlPrefix = "";
    return (
        (
            <Layout>
                <Seo title="找不到頁面" />
                <main className="not-found-page w-100 h-100 d-flex align-items-center justify-content-center" style={UrlService.getImageUrlStyle('404-lower-bg.svg')}>
                    <div className="d-flex flex-column align-items-center text-center not-found-page__center">
                        <img className="mw-100" src={UrlService.getImageUrl('404.png')} alt="404" title="404" />
                        <h1 className="font-weight-old">
                            噢，找不到頁面！
                        </h1>
                        <p className="text-center">
                            我們似乎無法找到您想瀏覽的頁面，
                            <br></br>
                            請檢查所輸入的網址或返回主頁。
                        </p>
                        <a className="btn btn-secondary d-flex align-items-center justify-content-center" href={`${localeUrlPrefix}/`}>
                            返回主頁
                        </a>
                    </div>
                </main>
            </Layout>
        )
    );
}

export default NotFoundPage
